// src/services/sharedSessionPlace.js
//
// Where this device is in a partner session: which session, which partner,
// and the answers so far. Partner answers only reach the shared session when
// that partner finishes, so without this a reload mid-way lost both the
// answers and the place, and reopening the join link said "Partner has
// already joined".
//
// Kept on this device only. The session code is the only key to a session,
// so this is never backed up (it isn't in services/hubSync.js SYNCED_KEYS).
// It is dropped after 8 days, the longest a session can live under
// firestore.rules, or as soon as the session turns out to be gone.
//
// Australian English throughout.

const PREFIX = 'relationshipCompass_sharedPlace:';
const MAX_AGE_MS = 8 * 24 * 60 * 60 * 1000;

/** { sessionCode, partnerNumber, partnerName, step, questionIndex, responses } */
export function savePlace(assessmentId, place) {
  try {
    localStorage.setItem(PREFIX + assessmentId, JSON.stringify({ ...place, savedAt: Date.now() }));
  } catch {
    /* storage blocked: a reload loses the place, as it did before */
  }
}

export function loadPlace(assessmentId) {
  try {
    const raw = localStorage.getItem(PREFIX + assessmentId);
    if (!raw) return null;
    const place = JSON.parse(raw);
    if (!place?.sessionCode || !place.partnerNumber || Date.now() - (place.savedAt || 0) > MAX_AGE_MS) {
      clearPlace(assessmentId);
      return null;
    }
    return place;
  } catch {
    return null;
  }
}

export function clearPlace(assessmentId) {
  try {
    localStorage.removeItem(PREFIX + assessmentId);
  } catch {
    /* nothing to clear */
  }
}
